<template>
    <div class="mailcenter">
        <div class="title">您好，{{ getUserInfo.name }}</div>
        <div class="subtitle">可发送邮件数量: <span class="shownum">{{ mySendEmailNum }}</span> / <span class="shownum">{{
            myTotleEmailNum }}</span></div>
        <div class="subtitle">邮件：<span class="shownum">{{ unreadStarNum.noReadNum }}</span> 封未读邮件，<span class="shownum">{{
            unreadStarNum.starMarkNum
        }}</span> 封星标邮件</div>

        <div class="aubox">
            <el-row :gutter="8">
                <el-col class="col-item" :span="8">
                    <el-card class="box-card">
                        <div class="platitem">
                            <div class="itemcontent">
                                我的关注
                            </div>
                            <div class="itemconut">
                                {{ boxInfo.concernNum }}
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col class="col-item" :span="8">
                    <el-card class="box-card">
                        <div class="platitem">
                            <div class="itemcontent">
                                发件箱
                            </div>
                            <div class="itemconut">
                                {{ boxInfo.sendEmailNum }}
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col class="col-item" :span="8">
                    <el-card class="box-card">
                        <div class="platitem">
                            <div class="itemcontent">
                                收件箱
                            </div>
                            <div class="itemconut">
                                {{ boxInfo.receiveEmailNum }}
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col class="col-item" :span="8">
                    <el-card class="box-card">
                        <div class="platitem">
                            <div class="itemcontent">
                                打开率
                            </div>
                            <div class="itemconut">
                                {{ boxInfo.openRate }}%
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col class="col-item" :span="8">
                    <el-card class="box-card">
                        <div class="platitem">
                            <div class="itemcontent">
                                回复率
                            </div>
                            <div class="itemconut">
                                {{ boxInfo.replyRate }}%
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col class="col-item" :span="8">
                    <el-card class="box-card">
                        <div class="platitem">
                            <div class="itemcontent">
                                合作联盟客
                            </div>
                            <div class="itemconut">
                                {{ boxInfo.cooperateNum }}
                            </div>
                        </div>
                    </el-card>
                </el-col>

            </el-row>
        </div>

        <el-card class="box-card" style="margin-top: 5px;">
            <div class="title">最近联系人</div>
            <div class="contact" v-for="item in recentContacts" :key="item.id">
                <el-row>
                    <el-col :span="5">
                        <div class="headsrc"> <el-avatar :size="35" :src="item.headSrc"></el-avatar></div>
                    </el-col>
                    <el-col :span="19">
                        <div class="name">{{ item.name }}</div>
                        <div class="subdesc">{{ item.defaultType }}</div>
                    </el-col>
                </el-row>
            </div>
        </el-card>

        <el-card class="box-card" style="margin-top: 5px;">
            <div class="title">建联数据概览</div>
            <el-radio-group size="small" v-model="dateType" style="margin-top: 10px;" @input="changeTabtype">
                <el-radio-button label="1">过去7天</el-radio-button>
                <el-radio-button label="2">过去30天</el-radio-button>
                <el-radio-button label="3">过去90天</el-radio-button>
                <el-radio-button label="4">过去一年</el-radio-button>
            </el-radio-group>
            <div class="charts">
                <div id="myChart1" :style="{ width: '100%', height: '300px' }"></div>
            </div>
        </el-card>

        <el-card class="box-card" style="margin-top: 5px;">
            <div class="title">联盟客地域分布</div>
            <el-table :data="regionList" style="width: 100%" :row-class-name="tableRowClassName">
                <el-table-column prop="rank" label="NO"></el-table-column>
                <el-table-column prop="countryName" label="国家/地区"></el-table-column>
                <el-table-column prop="sendNum" label="数量"></el-table-column>
            </el-table>
        </el-card>
    </div>
</template>
<script>
import { QUERYEMAILDATA, QUERYRECENTLYPERSON, QUERYALLIANCEAREA, QUERYNOREADSTARMARK, QUERYTOTALCOUNT, QUERY, QUERYMAINPERMIT, QUERYEMAILSENDANDTOTLENUM } from '@/api/emial'
import util from '@/utils/util'
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            mySendEmailNum: 0,
            myTotleEmailNum: 0,
            unreadStarNum: {},
            boxInfo: {},
            recentContacts: [],
            dateType: '1',
            newdatas: this.$moment().subtract(6, 'days').format('YYYY-MM-DD'),
            option1: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '5%',
                    top: '15%',
                    right: '5%',
                    bottom: '18%',
                    containLabel: true
                },
                legend: {
                    bottom: 0,
                    data: ['我的关注', '发件箱', '收件箱', '合作联盟客']
                },
                xAxis: [
                    {
                        type: 'category',
                        data: [],
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisLabel: {
                            // 旋转角度
                            rotate: 45
                        }
                    }
                ],
                yAxis: {
                    type: 'value',
                    name: '数量',
                    minInterval: 1,
                },
                series: [
                    {
                        name: '我的关注',
                        type: 'line',
                        symbolSize: 5,
                        color: '#FC6780',
                        data: []
                    },
                    {
                        name: '发件箱',
                        type: 'line',
                        symbolSize: 5,
                        color: '#FEC776',
                        data: []
                    },
                    {
                        name: '收件箱',
                        type: 'line',
                        symbolSize: 5,
                        color: '#958AFF',
                        data: []
                    },
                    {
                        name: '合作联盟客',
                        type: 'line',
                        symbolSize: 5,
                        color: '#2CD4D3',
                        data: []
                    }
                ],
                dataZoom: [
                    {
                        show: false, // 为true 滚动条出现
                        realtime: true,
                        type: 'slider', // 有type这个属性，滚动条在最下面，也可以不行，写y：36，这表示距离顶端36px，一般就是在图上面。
                        height: 10, // 表示滚动条的高度，也就是粗细
                        start: 0, // 表示默认展示20%～80%这一段。
                        end: 100,
                        handleSize: 0,      //两边手柄尺寸
                        dataBackground: {
                            areaStyle: {
                                color: '#fff'
                            }
                        },
                        backgroundColor: '#fff',
                        borderColor: "#ffffff",
                        fillerColor: '#fff',
                        moveOnMouseMove: true, //鼠标移动能触发数据窗口平移
                        moveOnMouseMove: true, //鼠标移动能触发数据窗口平移
                        zoomLock: true,         //是否只平移不缩放
                        showDetail: false, //拖拽时是否展示滚动条两侧的文字
                        zoomOnMouseWheel: true,  // 关闭滚轮缩放
                        moveOnMouseWheel: true, // 开启滚轮平移
                        moveOnMouseMove: true,  // 鼠标移动能触发数据窗口平移 
                        bottom: 10,
                    },
                    {//没有下面这块的话，只能拖动滚动条，鼠标滚轮在区域内不能控制外部滚动条
                        type: 'inside',
                        xAxis: 0,
                        zoomOnMouseWheel: false,  //滚轮是否触发缩放
                        moveOnMouseMove: true,  //鼠标滚轮触发滚动
                        moveOnMouseWheel: true
                    }
                ]
            },
            regionList: [],
        }
    },
    computed: {
        ...mapGetters(['getUserInfo']),
    },
    created() {
        this.queryEmailSendAndTotleNum()
        this.queryNoReadStarMark()
        this.queryTotalCount()
        this.queryRecentlyPerson()
        this.queryEmailData()
        this.queryAllianceArea()
    },
    methods: {
        // 可发邮件数量
        queryEmailSendAndTotleNum() {
            QUERYEMAILSENDANDTOTLENUM().then(res => {
                this.mySendEmailNum = res.data.body.sendEmailNum
                this.myTotleEmailNum = res.data.body.totleEmailNum
            })
        },
        //邮件中心-未读邮件星标邮件（数量）
        queryNoReadStarMark() {
            QUERYNOREADSTARMARK().then(res => {
                this.unreadStarNum = res.data.body
            })
        },
        // 我的关注，发件箱，收件箱，打开率，回复率，合作联盟客(数值）
        queryTotalCount() {
            QUERYTOTALCOUNT().then(res => {
                this.boxInfo = res.data.body
            })
        },
        // 最近联系人
        queryRecentlyPerson() {
            QUERYRECENTLYPERSON().then(res => {
                this.recentContacts = res.data.body
            })
        },
        // 折线图数据
        queryEmailData() {
            QUERYEMAILDATA({
                dayDate: this.newdatas
            }).then(res => {
                this.option1.xAxis[0].data = res.data.body.xdatas
                this.option1.series[0].data = res.data.body.concernDatas
                this.option1.series[1].data = res.data.body.sendDatas
                this.option1.series[2].data = res.data.body.receiveDatas
                this.option1.series[3].data = res.data.body.cooperateDatas
                this.$nextTick(() => {
                    this.drawPie1()
                })
            })
        },
        drawPie1() {
            let myChart = this.$echarts.init(document.getElementById("myChart1"));
            myChart.setOption(this.option1, true);
        },
        changeTabtype(e) {
            if (e == 1) {
                this.newdatas = this.$moment().subtract(6, 'days').format('YYYY-MM-DD')
                this.queryEmailData()
            } else if (e == 2) {
                this.newdatas = this.$moment().subtract(29, 'days').format('YYYY-MM-DD')
                this.queryEmailData()
            } else if (e == 3) {
                this.newdatas = this.$moment().subtract(89, 'days').format('YYYY-MM-DD')
                this.queryEmailData()
            } else if (e == 4) {
                this.newdatas = this.$moment().subtract(364, 'days').format('YYYY-MM-DD')
                this.queryEmailData()
            }
        },
        // 地域分布
        queryAllianceArea() {
            QUERYALLIANCEAREA().then(res => {
                this.regionList = res.data.body
            })
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 0) {
                return 'warning-row';
            } else {
                return 'success-row';
            }
            return '';
        }
    }
}
</script>
<style lang="less" scoped>
/deep/.el-table .warning-row {
    background: rgb(247, 215, 226) !important;
}

/deep/.el-table .success-row {
    background: rgb(235, 181, 200) !important;
}

.mailcenter {
    height: 100%;
    overflow-y: scroll;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    padding: 8px;
    background-color: #fff;

    .shownum {
        color: #be3c6e;
    }

    .title {
        font-weight: 600;
        font-size: 16px;
        margin-bottom: 8px;
    }

    .subtitle {
        font-size: 13px;
        margin-bottom: 15px;
    }

    /deep/.el-card__body {
        padding: 8px;
    }

    .aubox {
        .col-item {
            margin-bottom: 8px;
        }

        .box-card {
            position: relative;
            text-align: center;
        }

        .itemconut {
            margin-top: 8px;
            color: #be3c6e;
        }

    }

    .contact {
        margin: 8px;
        border-bottom: 1px dashed #ccc;
    }
}
</style>